import { effect, Injectable, signal } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { Plan, PlanFamily } from 'src/app/models/plan.model';
import { CacheLoaderService } from './cache-loader.service';
import { HttpClient } from '@angular/common/http';
import { OfficesService } from './franchises.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlansService {
  allPlansData = signal<Plan[]>([]);
  filteredPlansData = signal<Plan[]>([]);
  fullPlansList = signal<Plan[]>([]);

  readonly selectedPlan = signal<Plan | null>(null);

  planFamilies = signal<PlanFamily[]>([]);

  private baseUrl = environment.landmark_API_URL + '/plans';

  constructor(
    private http: HttpClient,
    private cacheLoader: CacheLoaderService<Plan>,
    private officeService: OfficesService,
    private familyCacheLoader: CacheLoaderService<PlanFamily>
  ) {
    this.populateAllplans();
    effect(() => {
      const fid = this.officeService.selectedOffice()?.PlanPrice_FID || this.officeService.selectedOffice()?.FID;
      console.log('plan pricing fid:', fid);
      if(fid) {
        this.filterLocalPlans(fid);
      }
    });
  }

  setSelectedPlan(plan: Plan | null) {
    this.selectedPlan.set(plan);
  }

  setPlanById(planId: number) {
    const plan = this.fullPlansList().find(p => p.PlanID === planId);
    console.log('setting plan by id', plan);
    if(plan) {
      this.selectedPlan.set(plan);
    }
  }

  updateAllData(newData: Plan[]) {
    this.allPlansData.set(newData);
  }

  updatePlanFamilies(newData: PlanFamily[]) {
    this.planFamilies.set(newData);
  }

  filterPlans(fid: number, plans: Plan[]) {
    // console.log('Original Plans:', plans);
    const filtered = plans.filter(plan => {
      // console.log('Checking Plan:', plan);
      return plan.PlanID !== 1 && plan.Available || plan.OfficePlans?.some(officePlan => officePlan.FID === fid);
    }).map(plan => {
      // console.log('Mapping Plan:', plan);
      return {
        ...plan,
        PlanPrices: plan.PlanPrices?.filter(price => price.FID === fid)
      };
    });
    this.filteredPlansData.set(filtered);
    // console.log('Filtered Plans:', filtered);
  }

  selectHighArcPlan(studioDocId: string, StyleID: number) {
    console.log('selectHighArcPlan triggered in plans-data.service.ts', studioDocId, StyleID);
    console.log('fullPlansList:', this.fullPlansList());
    const highArcPlan = this.fullPlansList().find(plan => plan.studioDocId === studioDocId && plan.StyleID === StyleID);
    if(highArcPlan) {
      return highArcPlan;
    }
    return null;
  }

  filterLocalPlans(fid:number) {
    const plans = this.allPlansData();
    this.filterPlans(fid, plans);
  }

  populatePlanFamilies() {
    this.familyCacheLoader.loadData('plans/families', (planFamilies) => {
      console.log('planFamilies:', planFamilies);
      this.updatePlanFamilies(planFamilies);
    }, 'planFamiliesCacheKey');
  }

  populatePlans(filterFID?: number) {
    this.getPricing().subscribe(plans => {
      // console.log('plans fetched:', plans);
      this.updateAllData(plans);
      if(filterFID) {
        this.filterPlans(filterFID, plans);
      }
    }
      );
  };

  updateBatch(plans: any): Observable<any> {
    return this.batchUpdateWithImages(plans).pipe(
      tap((res: any) => {
        console.log('plans updated:', res);
        // for(const plan of plans) {
        //   const index = this.allPlansData().findIndex(p => p.PlanID === plan.PlanID);
        //   if(index !== -1) {
        //     this.allPlansData()[index] = plan;
        //   }
        // }
      })
    );
  }

  populateAllplans() {
    console.log('loading plans')
      this.cacheLoader.loadData('plans', (plans) => {
        // console.log('plans loaded:', plans);
        // this.updateAllData(plans);
        this.fullPlansList.set(plans);
      }, 'plansCacheKey');
  }

  refreshPlans() {
    // this.http.get<Plan[]>(`${this.baseUrl}/`).subscribe(
    //   plans => this.plansSubject.next(plans)
    // );
    this.cacheLoader.loadData('plans', (plans) => {
      // console.log('Categories loaded:', categories);
      this.allPlansData.set(plans);
    }, 'plansCacheKey');
  }

  getallplans() {
    let plans: Plan[] = [];
    this.cacheLoader.loadData('plans', (plans) => {
      plans = plans;
      console.log('plans:', plans);
      return plans;
    }, 'plansCacheKey');
    return plans;
  }

  batchUpdateWithImages(formData: FormData): Observable<any> {
    // Log the FormData contents for debugging
    console.log('FormData contents:',formData);
  
    return this.http.post<any>(`${this.baseUrl}/plans/batch`, formData, {
      headers: {
        // Remove content-type header to let browser set it with boundary
        'Accept': 'application/json',
      },
      reportProgress: true,
      observe: 'response'  // Get full response for debugging
    }).pipe(
      tap((response: any) => console.log('Response:', response)),
      catchError(error => {
        console.error('Full error details:', error);
        if (error.error instanceof ErrorEvent) {
          // Client-side error
          console.error('Client error:', error.error.message);
        } else {
          // Server-side error
          console.error('Server error:', error.status, error.error);
        }
        return throwError(() => error);
      })
    );
  }

  updateBatchPlans(plans: any) {
    return this.http.post<Plan[]>(`${this.baseUrl}/batch`, plans, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError((error: any) => {
        console.error('Error in batch update:', error);
        return throwError(error);
      })
    );
  }

  getPricing():Observable<Plan[]> {
    return this.http.get<Plan[]>(`${this.baseUrl}/pricing`)
  }

}
